

























import { Component, Vue, Prop } from 'vue-property-decorator'
import ShowImg from '../ui/ShowImg.vue'
/**
 * 列表头部的热门推荐
 */
@Component({
  components: {
    ShowImg
  }
})
export default class HotTop extends Vue {

  @Prop()
  public hotList: any

  public mounted() {

  }

  protected goDetails(item: any) {
    this.$router.push({ name: 'goods-details', query: { id: item.id } })
  }

}
